
<template>
    <div id="canvas-container"></div>
</template>

<style>
#canvas-container {
    width: 70%;
    height: 100;
    position: absolute;
    z-index: -1;
    top: 0;
    left: 30%;
    right: 0;
    bottom: 0;
}
</style>

<script>
// Adapted from https://codepen.io/gadgetgnome/pen/jbPxwQ
// Thx to Pål Smitt-Amundsen

if (process.client) {
    window.THREE = require("three-js")();
}

export default {
    created: function() {
        this.maxFps = 30;
        this.then = Date.now();
        this.now = Date.now();
    },

    mounted: function() {
        $("#canvas-container").ready(() => {
            setTimeout(() => {
                var mousePos = { x: 0.35, y: 0.65 };
                // window.document.addEventListener("mousemove", function(event) {
                //     mousePos = {
                //         x: event.clientX / window.innerWidth,
                //         y: event.clientY / window.innerHeight
                //     };
                // });
                var phase = 0;

                let width = $("#canvas-container").width();
                let height = $("#canvas-container").height();

                var scene = new THREE.Scene();
                scene.background = new THREE.Color(0xf5f5f5);
                var camera = new THREE.PerspectiveCamera(
                    95,
                    width / height,
                    0.1,
                    1000
                );
                camera.position.z = 30;

                // create webglrenderer without dirty console log
                let log = console.log;
                console.log = function() {}
                var renderer = new THREE.WebGLRenderer();
                console.log = log;

                renderer.setSize(width, height);
                window.document
                    .getElementById("canvas-container")
                    .append(renderer.domElement);

                var boxSize = 0.15;
                //var geometry = new THREE.BoxGeometry(boxSize, boxSize, boxSize);
                var geometry = new THREE.SphereGeometry(boxSize, 12, 12);
                var materialGreen = new THREE.MeshBasicMaterial({
                    transparent: true,
                    color: 0x35495e,
                    opacity: 0.4,
                    side: THREE.DoubleSide
                });

                var pitchSegments = 24;
                var elevationSegments = pitchSegments / 2;
                var particles = pitchSegments * elevationSegments;
                var side = Math.pow(particles, 1 / 3);

                var radius = 16;

                var parentContainer = new THREE.Object3D();
                scene.add(parentContainer);

                function posInBox(place) {
                    return (place / side - 0.5) * radius * 1.2;
                }

                //Plant the seeds, grow some trees in a grid!
                for (var p = 0; p < pitchSegments; p++) {
                    var pitch = (Math.PI * 2 * p) / pitchSegments;
                    for (var e = 0; e < elevationSegments; e++) {
                        var elevation = Math.PI * (e / elevationSegments - 0.5);
                        var particle = new THREE.Mesh(geometry, materialGreen);

                        parentContainer.add(particle);

                        var dest = new THREE.Vector3();
                        dest.z = Math.sin(pitch) * Math.cos(elevation) * radius; //z pos in sphere
                        dest.x = Math.cos(pitch) * Math.cos(elevation) * radius; //x pos in sphere
                        dest.y = Math.sin(elevation) * radius; //y pos in sphere

                        particle.position.x = posInBox(
                            parentContainer.children.length % side
                        );
                        particle.position.y = posInBox(
                            Math.floor(parentContainer.children.length / side) %
                                side
                        );
                        particle.position.z = posInBox(
                            Math.floor(
                                parentContainer.children.length /
                                    Math.pow(side, 2)
                            ) % side
                        );

                        particle.userData = {
                            dests: dest,
                            speed: new THREE.Vector3()
                        };
                    }
                }

                var self = this;
                function render() {
                    requestAnimationFrame(render);
                    self.maxFps = 60;
                    self.now = Date.now();
                    let elapsed = self.now - self.then;
                    let fpsInterval = 1000 / self.maxFps;

                    if (elapsed > fpsInterval) {
                        self.then = self.now - (elapsed % fpsInterval);

                        // rendering code
                        phase += 0.001;
                        for (
                            var i = 0, l = parentContainer.children.length;
                            i < l;
                            i++
                        ) {
                            var particle = parentContainer.children[i];
                            var dest = particle.userData.dests.clone();
                            var diff = dest.sub(particle.position);
                            particle.userData.speed.divideScalar(1.02); // Some drag on the speed
                            particle.userData.speed.add(diff.divideScalar(400)); // Modify speed by a fraction of the distance to the dest
                            particle.position.add(particle.userData.speed);
                            //particle.lookAt(dest);
                        }

                        parentContainer.rotation.y = phase * 3;
                        parentContainer.rotation.x =
                            (mousePos.y - 0.5) * Math.PI;
                        parentContainer.rotation.z =
                            (mousePos.x - 0.5) * Math.PI;

                        renderer.render(scene, camera);
                    }
                }
                render();
            });
        });
    }
};
</script>